import NotPartnerBanks from './NotPartnerBanks';

export default NotPartnerBanks;
